import React from 'react';
import { Outlet } from 'react-router-dom';
import { PAGE_TYPE, SideNavContainer } from '@modules/members/utils';

/* Admin view-member shell for CAP historical documents (`/.../documents/{hhid}?referenceId=…`). */
const CapHistoricalDocumentsAdminLayout: React.FC = () => (
    <SideNavContainer page={PAGE_TYPE.HISTORICAL_DOCUMENTS}>
        <main className="desktop:grid-col-9" id="main-content">
            <Outlet />
        </main>
    </SideNavContainer>
);

export default CapHistoricalDocumentsAdminLayout;
